import { coreAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios";
import qs from "qs";

/**
 * 添加单个图元
 * @param data 图元数据
 * @param params 其他请求参数
 * - projectUuid: 图形ID，关联图元到指定图形（必填）
 * @returns Promise 解析为 AxiosResponse，包含新增图元的唯一标识
 */
export function createPrimitive(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/primitives`, data, {
        params: {
            ...params,
        }
    })
}
/**
 * 批量添加图元
 * @param data 图元数据列表，每个图元对象结构与单个图元相同
 * @param params 其他请求参数
 * - projectUuid: 图形ID，关联图元到指定图形（必填）
 * @returns Promise 解析为 AxiosResponse，包含批量添加的结果（布尔值）
 */
export function createPrimitiveMulti(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/primitives/multi`, data, {
        params: {
            ...params,
        }
    })
}
/**
 * 获取指定图形中的所有图元
 * @param projectUuid 图形唯一标识
 * @returns Promise 解析为 AxiosResponse，包含图元列表
 */
export function findPrimitivesInProject(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/primitives`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 删除指定图形中的图元
 * @param uuids 图元唯一标识列表
 * @param projectUuid 图形唯一标识
 * @param params 可选附加参数
 * @returns Promise 解析为 AxiosResponse，包含删除结果（布尔值）
 */
export function deletePrimitivesInProject(uuids: string[], projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/primitives/delete`, uuids, {
        params: {
            ...params,
            projectUuid: projectUuid,
        }
    })
}

/**
 * 获取某楼层的轴网图元
 * @param storeyUuid 
 * @param params 
 * @returns 
 */
export function findStoreyAxisNetPrimitive(storeyUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/storeys/${storeyUuid}/axis-net-primitive`, {
        params: {
            ...params,
        },
    })
}
/**
 * 添加单个轴网图元
 * @param data 图元数据
 * @param params 其他请求参数
 * @returns Promise 解析为 AxiosResponse，包含新增图元的唯一标识
 */
export function createAxisNetPrimitive(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/primitives/axis-net`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取某建筑的轴网图元
 */
export function findProjectAxisNetPrimitives(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/axis-net-primitives`, {
        params: {
            ...params,
        }
    })
}
/**
 * 根据uuid获取图元
 */
export function findPrimitivesByUuids(uuids: string[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/primitives/find`, uuids, {
        params: {
            ...params,
        }
    })
}
